'use strict';
moduleConfig.registerModule('eclipseApp.internet', ['eclipseApp.core']);
